import { useLingui } from '@lingui/react';

import MediaUploadError from './Upload/MediaUploadError';
import MediaSelectionError from './MediaSelectionError';

/**
 * Resolves a Media error's user-facing `MessageDescriptor` to a localized string using the
 * per-request Lingui instance from context. Returns `undefined` when the error has no
 * descriptor, so callers keep their existing `|| error.message` fallbacks.
 */
export default function useMediaErrorMessage(
  error?: MediaSelectionError | MediaUploadError
): string | undefined {
  const { i18n } = useLingui();
  return error?.userFacingDescriptor ? i18n._(error.userFacingDescriptor) : undefined;
}
